import styles from './Radio.module.scss'

import { v4 as uuidv4 } from 'uuid'
import { IRadioInputSettings } from '../../../inputs.interface'
import { IChangeValue } from '../../../../../interface/steps.interface'

interface Props {
  value: string
  currentValue: string | number
  handleChange: IChangeValue
  settings: IRadioInputSettings
}
const Radio = ({ value, currentValue, handleChange, settings }: Props) => {
  const id = uuidv4()
  const { name, label } = settings
  const handler = () => handleChange(name, value, false)

  return (
    <div className={styles.wrapper}>
      <input
        className={styles.input}
        id={id}
        type="radio"
        name={name}
        value={value}
        onChange={handler}
        checked={value === currentValue}
      />
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
    </div>
  )
}

export default Radio
